import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'darkenHexColor',
})
export class DarkenHexColorPipe implements PipeTransform {
  transform(value: string, factor = 0.2) {
    // Remove the "#" if present
    let hex = value.replace(/^#/, '');

    // Convert 3-digit hex to 6-digit
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('');
    }

    // Convert to RGB and apply darkening
    const r = Math.floor(parseInt(hex.slice(0, 2), 16) * (1 - factor));
    const g = Math.floor(parseInt(hex.slice(2, 4), 16) * (1 - factor));
    const b = Math.floor(parseInt(hex.slice(4, 6), 16) * (1 - factor));

    // Clamp values and convert back to hex
    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }
}
